export default __webpack_public_path__ + "static/media/auth-screen-illustration-1.ffdb27e7.svg";